export default __webpack_public_path__ + "static/media/deposit-icon.3d8c9acf.webp";